import { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import env from 'config/env'
import Icon from 'components/common/icon'
import styles from './styles.scss'

const ColorIcon = ({ color, iconImage, isSelected, onClick }) => (
  <button
    style={{ backgroundColor: color }}
    className={clsx('color-icon', 'color-icon__pdp', {
      '--selected': isSelected,
    })}
    onClick={!isSelected ? onClick : null}
    aria-label="color-icon"
  >
    <style jsx>{styles}</style>
    {iconImage && (
      <Icon
        size={20}
        alt="color-icon"
        className="color-icon__icon-image"
        src={`${env.IMG_HOST}${iconImage}`}
      />
    )}
  </button>
)

ColorIcon.defaultProps = {
  color: '',
  iconImage: undefined,
}

ColorIcon.propTypes = {
  color: PropTypes.string,
  iconImage: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default memo(ColorIcon)
